<template>
  <div class="terms-service-container">
    <van-nav-bar :title="$t('coinbase_hs_tit1')" left-text="返回" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: ''
    };
  },
  created() {
    this.getTermService()
  },
  methods: {
    navBack() {
      this.$router.replace('/');
    },
    async getTermService() {
      const res = await this.$api.getTermService()
      if(res.code == 200) {
        this.content = res.data.content
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.back {
  width: 30px;
  height: 15px;
}
.terms-service-container {
  .content {
    box-sizing: border-box;
    padding: 15px 20px;
    text-align: center;
    font-size: 12px;
    background: #fff;
    color: #000;
    word-break: break-all;
    p {
      word-break: break-all;
    }
  }
}
</style>